import styled from 'styled-components';

export const TreeWrapper = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  padding: 16px;

  .ant-tree {
    background: transparent;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .ant-tree .ant-tree-node-content-wrapper {
    display: flex;
    align-items: center;
    min-width: 0;
    padding: 0 6px;
    border-radius: 4px;
  }

  /* A lista de modelos do federado carrega o CSS GLOBAL do VirtualTreeView (a
     árvore da Autodesk), que fixa 300px na linha e no conteúdo e força a seleção
     transparente. Nossa árvore convive na mesma página, então desfaz aqui. */
  .ant-tree .ant-tree-treenode,
  .ant-tree .ant-tree-node-content-wrapper,
  .ant-tree .ant-tree-node-content-wrapper-open {
    width: 100%;
  }

  .ant-tree .ant-tree-treenode {
    align-items: center;
    padding-bottom: 0;
    border-radius: 4px;
  }

  /* A faixa é a LINHA inteira: o wrapper do conteúdo começa depois da seta e da
     indentação, e pintar só ele deixa a marcação pela metade. O fundo vai no
     treenode, e o wrapper fica transparente para não somar um segundo tom. */
  .ant-tree .ant-tree-treenode:hover {
    background: ${({ theme }) => theme.colors.surface.surfaceContainer};
  }

  /* Mesmo azul da árvore da Autodesk (treeNodeRowActive, VirtualTreeView.module.scss):
     as duas convivem na mesma lista de modelos e marcar de cores diferentes
     sugeriria que a seleção significa coisas diferentes. Valor cru porque não há
     token para ele — o dia que virar token, as duas trocam juntas. */
  .ant-tree .ant-tree-treenode-selected,
  .ant-tree .ant-tree-treenode-selected:hover {
    background: rgba(34, 204, 226, 0.15);
  }

  .ant-tree .ant-tree-node-content-wrapper,
  .ant-tree .ant-tree-node-content-wrapper:hover,
  .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: transparent !important;
  }
`;

export const EmptyState = styled.div`
  padding: 24px 16px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;
